import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { EASE } from "@/components/Reveal";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user && user.role === "admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back to the atelier.");
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-4 py-24 bg-bg2" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="w-full max-w-md card-surface p-8 sm:p-10"
      >
        <div className="text-center">
          <img src="/logo.jpg" alt="Sashti Jewels" className="mx-auto h-14 w-14 rounded-full object-cover border border-gold/40" />
          <p className="overline-tag mt-5">Restricted</p>
          <h1 className="mt-2 font-display text-3xl font-semibold">Admin Atelier</h1>
          <p className="mt-2 text-xs text-ink3 font-mono">Manage jewels, enquiries &amp; orders</p>
        </div>
        <div className="gold-hr my-7" />
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1.5 block font-cinzel text-[10px] uppercase text-ink2" style={{ letterSpacing: "0.2em" }}>Email</label>
            <input
              type="email" required className="field" placeholder="admin@sashtijewels.in"
              value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="mb-1.5 block font-cinzel text-[10px] uppercase text-ink2" style={{ letterSpacing: "0.2em" }}>Password</label>
            <input
              type="password" required className="field" placeholder="••••••••••"
              value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
            />
          </div>
          {error && (
            <p className="border border-red-300 bg-red-50 px-4 py-3 text-xs text-red-700" data-testid="admin-login-error">{error}</p>
          )}
          <button type="submit" className="btn-gold w-full justify-center" disabled={busy} data-testid="admin-login-submit">
            {busy ? "Verifying…" : "Enter the Atelier"}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-ink3">
          <Link to="/" className="hover:text-gold transition-colors">← Return to the storefront</Link>
        </p>
      </motion.div>
    </main>
  );
}
